"use client";
import React from "react";
import python from "../../../assets/svgs/python.svg";
import faq from "../../../assets/svgs/faqs.svg";
import llm from "@/assets/svgs/operator_icons/operator_icon_llm.svg";
import langChain from "@/assets/svgs/operator_icons/operator_icon_langchain.svg";
import fanIn from "@/assets/svgs/operator_icons/operator_icon_fan_in.svg";
import fanOut from "@/assets/svgs/operator_icons/operator_icon_fan_out.svg";
import {FileSearch2, Split, FileInput, Database} from "lucide-react";
import {OperatorTypeEnum} from "@/model/Workflow";

const OperatorIcon: React.FC<{type: string, size?: number}> = ({type, size = 24})  => {

    if (type === OperatorTypeEnum.PYTHON) {
        return <img src={python} alt="python-operator" width={size}/>
    } else if (type === OperatorTypeEnum.BRANCH_PYTHON) {
        return <Split size={size}/>
    } else if (type === OperatorTypeEnum.FAN_IN) {
        return <img src={fanIn} alt="fan-in-operator" width={size}/>
    } else if (type === OperatorTypeEnum.FAN_OUT) {
        return <img src={fanOut} alt="fan-out-operator" width={size}/>
    } else if (type === OperatorTypeEnum.SEARCH_DATA_SOURCE_RAG) {
        return <FileSearch2 size={size}/>
    } else if (type === OperatorTypeEnum.SEARCH_DATA_SOURCE_FAQ) {
        return <img src={faq} alt="faq-operator" width={size}/>
    } else if (type === OperatorTypeEnum.LLM){
        return <img src={llm} alt="llm" width={size}/>
    } else if (type === OperatorTypeEnum.LANGCHAIN) {
        return <img src={langChain} alt="langchain" width={size}/>
    } else if (type === 'input') {
        return <FileInput size={size}/>
    } else if (type === OperatorTypeEnum.MAP_REFERENCE_DATA_SOURCE) {
        return <Database size={size}/>
    } else {
        return null
    }
}

export default OperatorIcon
